// CPF
// Validate, generate and format CPF numbers
// https://github.com/fnando/cpf
import * as cpf from '@fnando/cpf'

const validator = {
  /**
   * Valida se um valor é do tipo CPF
   * @param  {String} value [description]
   * @param  {Object} args  [description]
   * @return {Boolean}      Retorna se o campo é valido
   */
  validate (value, args) {
    return cpf.isValid(value, true)
  }
}

export default validator
